// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import styles from "./UserChatMessage.module.css";

interface Props {
    message: string;
    useDarkMode: boolean;
}

export const UserChatMessage = ({ message, useDarkMode }: Props) => {

    return (
        <div className={styles.container}>
            <div className={useDarkMode ? styles.messageDark : styles.message}>
                {message}
            </div>
        </div>
    );
};
